const initialValue = {
  data: [],
  error: "",
};

const contactUsReducer = (state = initialValue, action) => {
  switch (action.type) {
    case "CONTACT_SUCCESS":
      return {
        data: action.payload,
        error: "",
      };
    case "CONTACT_FAILURE":
      return {
        data: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default contactUsReducer;
